/* Keep the official review flow; provide an escape route for slow embedded loads. */
(() => {
  const seen = new WeakSet();
  function scan() {
    document.querySelectorAll('iframe.kl_reviews__submission_modal__frame').forEach(frame => {
      if (seen.has(frame)) return;
      seen.add(frame);
      setTimeout(() => {
        if (!frame.isConnected) return;
        const url = new URL(frame.src, location.href);
        if (url.hostname !== 'reviews-app.services.klaviyo.com') return;
        url.searchParams.delete('onsiteEnabled');
        const help = document.createElement('div');
        help.className = 'loc-review-load-help';
        const zh = document.documentElement.lang.startsWith('zh');
        help.append(document.createTextNode(zh ? '表单加载较慢？ ' : 'Form loading slowly? '));
        const link = document.createElement('a');
        link.href = url.href; link.target = '_blank'; link.rel = 'noopener';
        link.textContent = zh ? '在新窗口打开评论表单' : 'Open review form in a new window';
        help.append(link);
        frame.parentElement.append(help);
      }, 12000);
    });
  }
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();
